import React, { useState, useEffect } from 'react';
import { Menu, X, Sparkles } from 'lucide-react';
import { siteData } from '../data/mock';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Services', href: '#services' },
    { name: 'About', href: '#about' },
    { name: 'Blog', href: '#blog' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'mx-4 mt-4' : 'mx-4 mt-4 md:mx-6 md:mt-6'
        }`}
      >
        <nav
          className={`flex items-center justify-between px-4 md:px-6 h-14 md:h-16 rounded-full transition-all duration-300 ${
            isScrolled
              ? 'bg-white/80 backdrop-blur-xl shadow-lg border border-black/5'
              : 'bg-white/60 backdrop-blur-md border border-black/10'
          }`}
        >
          {/* Logo */}
          <a
            href="#"
            className="flex items-center gap-2 text-[var(--text-primary)] font-semibold text-lg"
          >
            <div className="w-8 h-8 rounded-full bg-[var(--gradient-button)] flex items-center justify-center">
              <Sparkles className="w-5 h-5 text-[var(--text-primary)]" />
            </div>
            <span className="hidden sm:inline">{siteData.company.name}</span>
          </a>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="px-4 py-2 text-[var(--text-muted)] hover:text-[var(--text-primary)] hover:bg-black/5 rounded-full transition-all duration-200 font-medium"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Desktop CTA */}
          <div className="hidden md:block">
            <a href="#contact" className="btn-primary text-sm px-5 py-2.5">
              Book a Call
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden p-2 rounded-full hover:bg-black/5 transition-colors"
            aria-label="Toggle menu"
          >
            {isMobileMenuOpen ? (
              <X className="w-5 h-5 text-[var(--text-primary)]" />
            ) : (
              <Menu className="w-5 h-5 text-[var(--text-primary)]" />
            )}
          </button>
        </nav>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 z-40 pt-24 px-4 bg-white/95 backdrop-blur-lg md:hidden">
          <div className="flex flex-col gap-2">
            {navLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                onClick={() => setIsMobileMenuOpen(false)}
                className="px-4 py-3 text-[var(--text-primary)] hover:bg-black/5 rounded-xl transition-colors font-medium text-lg"
              >
                {link.name}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setIsMobileMenuOpen(false)}
              className="btn-primary mt-4 w-full"
            >
              Book a Call
            </a>
          </div>
        </div>
      )}
    </>
  );
};

export default Header;
